import { render, staticRenderFns } from "./ShowSubcomment.vue?vue&type=template&id=22003eb5&"
import script from "./ShowSubcomment.vue?vue&type=script&lang=js&"
export * from "./ShowSubcomment.vue?vue&type=script&lang=js&"
import style0 from "./ShowSubcomment.vue?vue&type=style&index=0&id=22003eb5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports